export const _typeStr = 'string' as const;
export const _typeNum = 'number' as const;
export const _typeBool = 'boolean' as const;
export const _typeObj = 'object' as const;
export const _typeFunc = 'function' as const;
export const _typeUndef = 'undefined' as const;
export const _typeSymbol = 'symbol' as const;

export const _strEmpty = '' as const;

export const _numZero: number = 0;

export const _errDenominatorZero =
  'The denominator cannot be 0, NaN, or Infinity';
